import Helpers from '@Apis/helpers';

class CommonServiceMiddleware {
  callAPI = async ({
    body,
    method,
    query,
    url,
    file,
  }) => {
    const _method = Helpers[method];
    // add logic to convert the query object to a query string with URL safe.
    const queryString = Helpers.convertObjectToQueryString(query);
    const response = await _method({
      url: `${url}?${queryString}`,
      data: body,
      file,
    });
    return response;
  }
}
export default CommonServiceMiddleware;
